import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { APIClient } from "../../../helpers/ApiHelper";

// AsyncThunk: ChatGPT API'ye mesaj gönderir ve yanıt alır
export const fetchChatGPTResponse = createAsyncThunk(
    "chat/fetchChatGPTResponse",
    async ({ message, chatHistory }, thunkAPI) => {
      try {
        const apiClient = new APIClient();
        const data = {
          model: "gpt-3.5-turbo",
          messages: chatHistory.map((chat) => ({
            role: chat.sender === "user" ? "user" : "assistant",
            content: chat.message,
          })).concat({ role: "user", content: message }),
        };
        const response = await apiClient.postChatGPT(data);
  
        if (!response || !response.choices || !response.choices[0].message.content) {
          console.error("Invalid ChatGPT API response:", response);
          throw new Error("ChatGPT yanıtı geçerli değil");
        }
  
        // Yalnızca ChatGPT'nin döndürdüğü mesajı döndür
        return response.choices[0].message.content;
      } catch (error) {
        console.error("Error in fetchChatGPTResponse:", error);
        return thunkAPI.rejectWithValue(
          error.response ? error.response.data : error.message
        );
      }
    }
  );
  
  
  const assistantNames = {
    en: "Aimee Assistant",
    tr: "Aimee Asistan",
    sp: "Aimee Asistente",
    fr: "Aimee Assistant",
    gr: "Aimee Assistent",
  };

const chatSlice = createSlice({
  name: "chat",
  initialState: {
    chatHistory: [], // Sohbet geçmişi
    loading: false, // Yüklenme durumu
    error: null, // Hata mesajları
  },
  reducers: {
    addUserMessage: (state, action) => {
      state.chatHistory.push({ sender: "user", message: action.payload });
    },
    addAssistantMessage: (state, action) => {
      state.chatHistory.push({ sender: "assistant", message: action.payload });
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchChatGPTResponse.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchChatGPTResponse.fulfilled, (state, action) => {
        state.loading = false;
        state.chatHistory.push({
          sender: "assistant",
          message: action.payload,
        });
      })
      .addCase(fetchChatGPTResponse.rejected, (state, action) => {
        console.error("ChatGPT request failed:", action.payload);
        state.loading = false;
        state.error = action.payload || "An unknown error occurred";
      });
  },
});

export const { addUserMessage, addAssistantMessage } = chatSlice.actions;
export default chatSlice.reducer;
